import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {IPromocion} from './promocion';
import {catchError, tap, map} from 'rxjs/operators';
import * as myGlobals from './../global';
import {HttpClientSecured} from '../services/http-client-secured';
import {HttpErrorValidator} from '../services/http-error-validator';

@Injectable({
  providedIn: 'root'
})
export class PromocionesService {
  formData: IPromocion;

  private _promocionesURL = myGlobals.baseApi + '/webadmin/v1/promotions';
  private _addPromocionURL = myGlobals.baseApi + '/webadmin/v1/promotion';

  constructor(private http: HttpClientSecured, private httpErrorValidator: HttpErrorValidator) {
  }

  getPromociones(): Observable<IPromocion[]> {
    return this.http.get<IPromocion[]>(this._promocionesURL).pipe(
      tap(data => console.log('All: ' + JSON.stringify(data))),
      catchError(this.handleError)
    );
  }

  getPromocion(id: number): Observable<IPromocion | undefined> {
    return this.getPromociones().pipe(map((promociones: IPromocion[]) => promociones.find(p => p.id === id)));
  }

  addPromocion(bin) {
    return this.http.post<any>(this._addPromocionURL, bin);
  }

  private handleError(err: HttpErrorResponse) {
    this.httpErrorValidator.validateError(err);

    let errorMessage = '';
    if (err.error instanceof ErrorEvent) {
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
